import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../shared/api/client'
import type { ProcurementDashboardDto, ProcurementPeriodKey } from './types'

export interface ProcurementPeriodState {
  key: ProcurementPeriodKey
}

export function useProcurementPeriod() {
  const [state, setState] = useState<ProcurementPeriodState>({ key: 'week' })
  const setKey = (key: ProcurementPeriodKey) => setState({ key })
  return { state, setKey }
}

async function fetchProcurementDashboard(
  p: ProcurementPeriodState,
): Promise<ProcurementDashboardDto> {
  const res = await apiClient.get<{ success: true; data: ProcurementDashboardDto }>(
    '/dashboard/procurement',
    { params: { period: p.key } },
  )
  return res.data.data
}

export function useProcurementDashboard(period: ProcurementPeriodState) {
  return useQuery({
    queryKey: ['dashboard', 'procurement', period.key],
    queryFn: () => fetchProcurementDashboard(period),
    staleTime: 15_000,
    refetchInterval: 60_000,
  })
}
